module.exports = __webpack_public_path__ + "img/14ry_bannertp.c0a10012.png";